import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import Navbarside from "../component/Navbarside";
import { enquiry } from "./../store/slices/enquiry";
import Moment from "moment";
import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";
import { ExportToExcel } from "./ExportToExcel";
import Footer from "./footer";

function TravelPackageEnquiry() {
  const [expertises, setexpertise] = useState([]);
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [data, setData] = React.useState([]);
  const fileName = "TravelPackageEnquiry";

  React.useEffect(() => {
    const fetchData = () => {
      axios
        .get(API_PATHS.getEnquiry + "?enquiryFor=travelPackage")
        .then((postData) => {
          // reshaping the array
          const customHeadings = postData.data.data.map((item) => ({
            "Client Name": item.name,
            "Client Email": item.email,
            "Client Mobile": item.contactNumber,
            "Client Message": item.message,
            "Travel Date": Moment(item.travelDate).format("DD-MM-YYYY"),
            "No.of Pax": item.peopleCount,
            "Date of Enquiry": Moment(item.created_at).format("DD-MM-YYYY"),
          }));

          setData(customHeadings);
        });
    };
    fetchData();
  }, []);
  React.useEffect(() => {
    dispatch(enquiry())
      .unwrap()
      .then((data) => {
        setexpertise(data.user.data);
      })
      .catch(({ message }) => {
        alert(message);
      });
  }, [dispatch]);

  return (
    <body data-col="2-columns" className=" 2-columns ">
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-success">
                        <h4 className="card-title">
                          Travel Package Enquiry &nbsp; &nbsp;
                          <ExportToExcel apiData={data} fileName={fileName} />
                        </h4>
                      </div>
                    </div>
                    <div className="card-body collapse show">
                      <div className="card-block card-dashboard table-responsive">
                        <table className="table table-striped table-bordered zero-configuration">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Mobile</th>
                              <th>Message</th>
                              <th>Date of Travel</th>
                              <th>No.of Pax</th>
                              <th>Enquired On</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <tbody>
                                {expertises.map(
                                  (TravelPackageEnquiryVal, index) => (
                                    <tr key={index}>
                                      <td>{TravelPackageEnquiryVal.name}</td>
                                      <td>{TravelPackageEnquiryVal.email}</td>
                                      <td>
                                        {TravelPackageEnquiryVal.contactNumber}
                                      </td>
                                      <td>{TravelPackageEnquiryVal.message}</td>
                                      <td>
                                        {Moment(
                                          TravelPackageEnquiryVal.travelDate
                                        ).format("DD-MM-YYYY")}
                                      </td>
                                      <td>
                                        {TravelPackageEnquiryVal.peopleCount}
                                      </td>
                                      <td>
                                        {Moment(
                                          TravelPackageEnquiryVal.created_at
                                        ).format("DD-MM-YYYY")}
                                      </td>
                                      <td>{TravelPackageEnquiryVal.source}</td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}
export default TravelPackageEnquiry;
